/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPianoIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-piano"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5 21.65Q3.9 21.65 3.13 20.88Q2.35 20.1 2.35 19L2.35 5Q2.35 3.9 3.13 3.13Q3.9 2.35 5 2.35L19 2.35Q20.1 2.35 20.88 3.13Q21.65 3.9 21.65 5L21.65 19Q21.65 20.1 20.88 20.88Q20.1 21.65 19 21.65ZM5 19L7.83 19L7.83 14.82L7.83 14.82Q7.3 14.82 6.94 14.46Q6.58 14.1 6.58 13.57L6.58 5L5 5Q5 5 5 5Q5 5 5 5L5 19Q5 19 5 19Q5 19 5 19ZM16.2 19L19 19Q19 19 19 19Q19 19 19 19L19 5Q19 5 19 5Q19 5 19 5L17.45 5L17.45 13.57Q17.45 14.1 17.09 14.46Q16.73 14.82 16.2 14.82L16.2 14.82ZM9.97 19L14.05 19L14.05 14.82L14.05 14.82Q13.53 14.82 13.16 14.46Q12.8 14.1 12.8 13.57L12.8 5L11.22 5L11.22 13.57Q11.22 14.1 10.86 14.46Q10.5 14.82 9.97 14.82L9.97 14.82Z" fill={color} />
    </svg>
  );
}
